var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowBackCurrentColor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 16
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 8l7 7M8 1L1 8m18 0H1",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 2
})));
export default SvgArrowBackCurrentColor;